module.exports = "<div class=\"container\">\r\n\t<app-header *ngIf=\"isLoggedIn\"></app-header>\r\n\t<app-header-logged-out *ngIf=\"!isLoggedIn\"></app-header-logged-out>\r\n\t<section>\r\n\t\t<router-outlet></router-outlet>\r\n\t</section>\r\n\r\n\t<ng-template ngbModalContainer></ng-template>\r\n\r\n\t<footer class=\"footer content-box\">\r\n\t\t<small class=\"mr-3\"><a href=\"mailto:recoghelp@gmail.com\">Get support</a></small>\r\n\t\t<small>&copy; 2017 Alec Sorensen</small>\r\n\t</footer>\r\n\t\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Alec/Documents/dev/recog/recog/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main